import { FC, useState } from 'react';
import { Chip, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useUserSubscriptionHistories } from '../../../../hooks/useUser';
import { fmtDate, fmtDateOnly, SUBSCRIPTION_STATUS_COLORS, SUBSCRIPTION_STATUS_LABELS } from '../../userShowUtils';
import { PaginatedSection } from '../../userShowComponents';

/** ④-6. 구독 이력 — 구독 결제 이력 */
const SubscriptionTab: FC<{ userId: number }> = ({ userId }) => {
    const [page, setPage] = useState(1);
    const { data, isLoading } = useUserSubscriptionHistories(userId, page - 1);
    const items = data?.content ?? [];

    return (
        <PaginatedSection
            loading={isLoading} empty={items.length === 0} emptyText="구독 이력이 없습니다."
            page={page} totalPages={data?.totalPages ?? 0} onPageChange={setPage}
        >
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>구매일</TableCell>
                        <TableCell>플랫폼</TableCell>
                        <TableCell>구독 유형</TableCell>
                        <TableCell>만료일</TableCell>
                        <TableCell align="right">결제금액</TableCell>
                        <TableCell>상태</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {items.map((h) => (
                        <TableRow key={h.id}>
                            <TableCell sx={{ whiteSpace: 'nowrap' }}>{fmtDate(h.purchaseDate)}</TableCell>
                            <TableCell><Chip label={h.platform} size="small" variant="outlined" /></TableCell>
                            <TableCell>
                                <Typography variant="body2">{h.subscriptionType}</Typography>
                                {h.isTrial && <Chip label="체험" size="small" color="info" sx={{ ml: 0.5 }} />}
                            </TableCell>
                            <TableCell sx={{ whiteSpace: 'nowrap' }}>{fmtDate(h.expiresDate)}</TableCell>
                            <TableCell align="right">{h.price.toLocaleString()} {h.currency}</TableCell>
                            <TableCell>
                                <Chip
                                    label={SUBSCRIPTION_STATUS_LABELS[h.status]} size="small"
                                    color={SUBSCRIPTION_STATUS_COLORS[h.status]}
                                />
                                {h.cancelledDate && (
                                    <Typography variant="caption" color="text.secondary" display="block">
                                        취소: {fmtDateOnly(h.cancelledDate)}
                                    </Typography>
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </PaginatedSection>
    );
};

export default SubscriptionTab;
